import { WorkItemTypeConfig } from "../../model/ProcessApi";
import { vsServiceName, WorkItemService } from "./service";

export const vsProviderName = `${vsServiceName}Provider`;

export class WorkItemServiceProvider {
  $get = [() => new WorkItemService(this.workItemTypes)];

  private workItemTypes: Map<string, WorkItemTypeConfig> = new Map();

  addWorkItemType(config: WorkItemTypeConfig) {
    this.workItemTypes.set(config.name, config);
  }
}
